import { theme } from "../../../theme/restyle/theme";

export type StripesColorType =
  | "primary"
  | "secondary"
  | "member"
  | "guest"
  | "caddie"
  | "staff"
  | "customer"
  | "unknownCustomer"
  | "unknownMemberHold"
  | "memberHold"
  | "unknownGuest"
  | "newGuest"
  | "A"
  | "B"
  | "C"
  | "D"
  | "E"
  | "F";

type StripeColors = {
  primaryFill: string;
  secondaryFill: string;
};

export const getStripesColors = (
  type: StripesColorType = "member"
): StripeColors => {
  switch (type) {
    case "guest":
    case "unknownGuest":
    case "newGuest": {
      return {
        secondaryFill: theme.colors["surface-main-secondary-subtle"],
        primaryFill: theme.colors["surface-main-secondary-subtlest"],
      };
    }

    case "customer":
    case "unknownCustomer": {
      return {
        primaryFill: theme.colors["surface-user-selectable-colorC-subtle"],
        secondaryFill: theme.colors["surface-user-selectable-colorC-subtlest"],
      };
    }

    case "A":
    case "B":
    case "C":
    case "D":
    case "E":
    case "F": {
      return {
        secondaryFill:
          theme.colors[`surface-user-selectable-color${type}-subtle`],
        primaryFill:
          theme.colors[`surface-user-selectable-color${type}-subtlest`],
      };
    }

    case "staff": {
      return {
        secondaryFill: theme.colors["surface-user-selectable-colorC-subtle"],
        primaryFill: theme.colors["surface-user-selectable-colorC-subtlest"],
      };
    }

    case "primary": {
      return {
        primaryFill: theme.colors["surface-primary"],
        secondaryFill: theme.colors["surface-secondary"],
      };
    }

    case "secondary": {
      return {
        primaryFill: theme.colors["surface-secondary"],
        secondaryFill: theme.colors["surface-primary"],
      };
    }

    case "member":
    case "memberHold":
    case "unknownMemberHold":
    case "caddie":
    default: {
      return {
        primaryFill: theme.colors["surface-main-primary-subtle"],
        secondaryFill: theme.colors["surface-main-primary-subtlest"],
      };
    }
  }
};
